import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { CloseButton } from '../CloseButton/index.js';
import { useModalContext } from './Modal.js';

const ModalCloseButton = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    onClick,
    ...rest
  } = _ref;
  const {
    onClose
  } = useModalContext();
  return /*#__PURE__*/React__default.createElement(CloseButton, _extends({
    ref: forwardedRef,
    onClick: e => {
      onClose();
      onClick && onClick(e);
    }
  }, rest));
});

export { ModalCloseButton };
